export default {
  validationError: {
    id: 'bo_staff_composable_use_standardized_api_validation_errors_validation_error',
    defaultMessage: 'Validation error',
  },
}
